import type { LWApiPublicAssetDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import getAssetsNewOrderedAddOns from './getAssetsNewOrderedAddOns';
import useNewOrderedAddOns from './useNewOrderedAddOns';

/**
 * Lists the add-ons ordered for one server that the server's association
 * details do not list yet. `isLoading` stays true until the ordered add-ons
 * have loaded.
 */
const useAssetNewOrderedAddOns = (
	asset?: Pick<
		LWApiPublicAssetDetailsResultRawI,
		'uniq_id' | 'associationDetails'
	>,
) => {
	const { newOrderedAddOns, isLoading } = useNewOrderedAddOns();

	return {
		assetNewOrderedAddOns: getAssetsNewOrderedAddOns(
			newOrderedAddOns,
			asset ? [asset] : [],
		),
		isLoading,
	};
};

export default useAssetNewOrderedAddOns;
